import { render, staticRenderFns } from "./ModuleCascader.vue?vue&type=template&id=f6d67238&"
import script from "./ModuleCascader.vue?vue&type=script&lang=js&"
export * from "./ModuleCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports